export { default } from './GoodIdButton'
